import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiList = {
  styleOverrides: { root: { '--ListItem-gap': '10px', paddingBlock: '4px' } },
} satisfies Components<Theme>['MuiList'];
